$('.amr_bf_items').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  autoplay:true,
  speed: 800,
  cssEase: 'linear'
});
  // nlo testimonials slider left side
    $('.amr_testimonials_left').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay:true,
    speed: 3000,
    fade: true,
    cssEase: 'linear'
  });
  // nlo testimonials slider Right side
    $('.amr_testimonials_right').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay:true,
    speed: 3000,
    fade: true,
    cssEase: 'linear'
    // rtl: true
  });
  // nlo testimonials slider mobile
    $('.amr_testimonials_mobile').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay:true,
    speed: 3000,
    fade: true,
    cssEase: 'linear'
  });
  // Featured Product Slider
    $('.amr_featured_slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    dots:false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  // nlo Featured In side
    $('.amr_fbrands_list').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
    
    $('.arz_pd_list').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }); 
  // nlo Ingredients
    $('.amr_ingredients_list').slick({
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

    
    $('.amr_ingredients_list2').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:true,
    dots:false,
    autoplay:false,
    speed: 300,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  // nlo social videos
    $('.amr_follow_us_videos.amr_follow_us_videos_mobile').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows:true,
    dots:false,
    autoplay:false,
    speed: 300,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // nlo Product Ingredients
    $('.arz_prod_ing_items').slick({
    infinite: true,
    centerPadding: '20px',
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    dots:false,
    autoplay:false,
    speed: 300,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // nlo Product Icons Tab
    $('.amr_prod_icon_list').slick({
    infinite: true,
    centerPadding: '20px',
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    dots:false,
    autoplay:false,
    speed: 300,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


$(document).ready(function () {
      $(".product-block.product-block--tab.onloadopen button.collapsible-trigger").addClass("is-open");
      $(".product-block.product-block--tab.onloadopen .collapsible-content").addClass("is-open"); 
});

   $(".amr_address_lnk").click(function() {
        $(this).closest(".amr_AD_tab_grup").addClass("adres_active");
    });
   $(".amr_AD_tablinks").click(function() {
        $(this).closest(".amr_AD_tab_grup").removeClass("adres_active");
    });

$(document).ready(function () {
  $('.points_rewards_refferals_content a').click(function() {
  function runFunction() {
    let iframeContent = $('#smile-ui-container iframe.smile-panel-frame').contents().find('.panel-fixed-header .flex-truncate .text-truncate').html();
    let iframeContentff = parseInt(iframeContent.replace(/[a-z]/ig, ''));
    if (iframeContentff <= 749){
      $('body.template-customers-account').addClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_princess");
      $('body.template-customers-account').removeClass("smile_queen");
    }
    else if (iframeContentff >= 750 && iframeContentff <= 1499){
      $('body.template-customers-account').addClass("smile_princess");
      $('body.template-customers-account').removeClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_queen");
    }
    else if (iframeContentff >= 1500){
      $('body.template-customers-account').addClass("smile_queen");
      $('body.template-customers-account').removeClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_princess");
    }
    }
setTimeout(runFunction, 1000);
setTimeout(runFunction, 3000);
setTimeout(runFunction, 5000);
setTimeout(runFunction, 7000);
  runFunction();
});



  function runFunction() {
    let iframeContent = $('#smile-ui-container iframe.smile-panel-frame').contents().find('.panel-fixed-header .flex-truncate .text-truncate').html();
    let iframeContentff = parseInt(iframeContent.replace(/[a-z]/ig, ''));
    if (iframeContentff <= 749){
      $('body.template-customers-account').addClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_princess");
      $('body.template-customers-account').removeClass("smile_queen");
    }
    else if (iframeContentff >= 750 && iframeContentff <= 1499){
      $('body.template-customers-account').addClass("smile_princess");
      $('body.template-customers-account').removeClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_queen");
    }
    else if (iframeContentff >= 1500){
      $('body.template-customers-account').addClass("smile_queen");
      $('body.template-customers-account').removeClass("smile_duchess");
      $('body.template-customers-account').removeClass("smile_princess");
    }
    }
setTimeout(runFunction, 1000);
setTimeout(runFunction, 3000);
setTimeout(runFunction, 5000);
setTimeout(runFunction, 7000);
  runFunction();

});



function add_to_cart_grid(variantid,qty){
    var id = variantid;
    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
  }



$(document).ready(function(){
  windowURL = window.location.href;
  console.log(windowURL)
  if(windowURL == 'https://www.shedavi.com/apps/track123'){
    $('meta[property="og:title"]').attr('content', 'Shedavi | Track Order Status');
    $('head > title').text('Shedavi | Track Order Status');
    $('meta[property="og:description"], meta[name="description"]').attr('content', 'Check on the status of your Shedavi natural hair care products order here.');
  }
  if(windowURL == 'https://www.shedavi.com/policies/privacy-policy'){
    $('meta[property="og:title"]').attr('content', 'Shedavi | Privacy Policy');
    $('head > title').text('Shedavi | Privacy Policy');
    $('meta[property="og:description"], meta[name="description"]').attr('content', 'This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from www.shedavi.com.');
  }
});



/* Subscription widget price bold */
  function wrapPriceAndAddBodyClass() {
    const labelSpan = document.querySelector('.rc-radio__label');
    if (labelSpan && labelSpan.textContent.includes('$')) {
      // document.body.classList.add('subscription-widgetAvailable');

      const fullText = labelSpan.textContent;
      const [labelText, priceText] = fullText.split('$');
      labelSpan.textContent = ''; 

      const labelSpanText = document.createTextNode(labelText.trim() + ' ');

      const priceSpan = document.createElement('span');
      priceSpan.textContent = `$${priceText.trim()}`;
      priceSpan.classList.add('price-highlight'); 

      labelSpan.appendChild(labelSpanText);
      labelSpan.appendChild(priceSpan);
    } 
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if the target element exists
        if (document.querySelector('.rc-radio__label')) {
          wrapPriceAndAddBodyClass();
          observer.disconnect(); 
          break;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
/* Subscription widget price bold */



/* 27/11/2024 */
// document.addEventListener("DOMContentLoaded", function () {
//     const targetSelector = '#epb_container';

//     const announcementObserver = new MutationObserver((mutations) => {
//         mutations.forEach((mutation) => {
//             const targetDivMain = document.querySelector(targetSelector);
//             if (targetDivMain && targetDivMain.style.height) {
//                 // Add a class to the target div
//                 document.querySelector('body').classList.add('epContent_loaded');
                
//                 // Stop observing once the target is found
//                 announcementObserver.disconnect();
//             }
//         });
//     });

//     announcementObserver.observe(document.body, { childList: true, subtree: true });
// });
/* 27/11/2024 */
